import { DEFAULT_TITLE_OPTS, titleWithRoleUI } from '../../definitions';
import content from '../../locales/en/content.json';
import applicantInformation from './applicantInformation';
import applicantSsn from './applicantSsn';

const TITLE_TEXT = content['supplemental--enrollment-status-title'];
const DESC_TEXT = content['supplemental--enrollment-status-description'];

const { applicantName, applicantDob } = applicantInformation.uiSchema;
const { applicantMemberNumber } = applicantSsn.uiSchema;

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.beneficiary),
    applicantName,
    applicantDob,
    applicantMemberNumber,
  },
  schema: {
    type: 'object',
    required: [
      ...applicantInformation.schema.required,
      ...applicantSsn.schema.required,
    ],
    properties: {
      ...applicantInformation.schema.properties,
      ...applicantSsn.schema.properties,
    },
  },
};
